import { render, staticRenderFns } from "./PortalLogin.vue?vue&type=template&id=20cc34f5&"
import script from "./PortalLogin.vue?vue&type=script&lang=js&"
export * from "./PortalLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports